import CElement from './CElement'

class CData {
  constructor(prevConnectedDot, connectedDot, nextConnectedDot) {
    this.prevConnectedDot = prevConnectedDot
    this.connectedDot = connectedDot
    this.nextConnectedDot = nextConnectedDot
  }

  elements() {
    const elements = []
    var prevElement = null
    for (var dot of this.connectedDot.dots) {
      const element = CElement.with(dot)
      if (prevElement !== null && prevElement.kind === CElement.KIND.TEXT && element.kind === CElement.KIND.TEXT) {
        elements.push(CElement.with(null))
      }
      elements.push(element)
      prevElement = element
    }
    return elements
  }
}

export default CData


// WEBPACK FOOTER //
// ./src/App/CData.js